import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  ordersToRetrieveFilters: { filter: '', id_warecloud: '', page: 1 },
  ordersToDeliverFilters: { filter: '', id_city: '' },
  ordersToReturnFilters: { filter: '', id_warecloud: '', page: 1 },
  ordersModalConfig: {
    show: false,
    modalType: '',
    titleOpening: null,
    order: null,
  },
  cities: [],
  wareclouds: [],
  toRetrieveCounter: null,
  toDeliverCounter: null,
  toReturnCounter: null,
  dialogs: {
    closeConfirmation: false,
    mapRoute: false,
  },
  orderMap: {
    latitude: '',
    longitude: '',
  },
  orderQR: null,
  confirmationAnalytics: '',
  scanQROrder: null,
};

const orderSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    setOrdersToRetrieveFilters(state, action) {
      state.ordersToRetrieveFilters = action.payload;
    },
    setOrdersToDeliverFilters(state, action) {
      state.ordersToDeliverFilters = action.payload;
    },
    setOrdersToReturnFilters(state, action) {
      state.ordersToReturnFilters = action.payload;
    },
    setOrdersModalConfig(state, action) {
      state.ordersModalConfig = action.payload;
    },
    setCities(state, action) {
      state.cities = action.payload;
    },
    setWareclouds(state, action) {
      state.wareclouds = action.payload;
    },
    setToDeliverCounter(state, action) {
      state.toDeliverCounter = action.payload;
    },
    setToRetrieveCounter(state, action) {
      state.toRetrieveCounter = action.payload;
    },
    setToReturnCounter(state, action) {
      state.toReturnCounter = action.payload;
    },
    openModal: (state, action) => {
      state.dialogs[action.payload] = true;
    },

    closeModal: (state, action) => {
      state.dialogs[action.payload] = false;
    },

    setOrderRoute: (state, action) => {
      state.orderMap = action.payload;
    },
    setOrderQR: (state, action) => {
      state.orderQR = action.payload;
    },
    setConfirmationAnalytics: (state, action) => {
      state.confirmationAnalytics = action.payload;
    },
    setScanQROrder: (state, action) => {
      state.scanQROrder = action.payload;
    },
  },
});

export const {
  setOrdersToRetrieveFilters,
  setOrdersToDeliverFilters,
  setOrdersToReturnFilters,
  setOrdersModalConfig,
  setCities,
  setWareclouds,
  setToDeliverCounter,
  setToRetrieveCounter,
  setToReturnCounter,
  openModal: openToDeliverToClientModals,
  closeModal: closeToDeliverToClientModals,
  setOrderRoute,
  setOrderQR,
  setConfirmationAnalytics,
  setScanQROrder,
} = orderSlice.actions;

export default orderSlice.reducer;
